import React from "react";
import { FaSearch } from "react-icons/fa";

const UpperSection = ({ title, searchQuery, setSearchQuery }) => {
  return (
    <div className="flex w-full justify-between items-center">
      <h1 className="text-[24px] font-semibold text-adminTextSecondary">
        {title}
      </h1>
      <div>
        <FaSearch className="absolute m-3 text-textSecondary" />
        <input
          type="search"
          id="search"
          name="Search"
          placeholder="Search.."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value.toLowerCase())}
          className="h-[40px] sm:w-[250px] w-[100px] pl-[40px] pr-[20px] rounded-[4px] border border-adminMainBorder focus:outline-none"
        />
      </div>
    </div>
  );
};

export default UpperSection;
